"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuizQuestion = void 0;
class QuizQuestion {
    constructor(data) {
        this.id = null;
        this.answer = null;
        this.correct = false;
        this.percentage = null;
        if (data) {
            this.id = data.id;
            this.answer = data.answer;
            this.correct = data.correct;
            this.percentage = data.percentage;
        }
    }
}
exports.QuizQuestion = QuizQuestion;
//# sourceMappingURL=QuizQuestion.js.map